import { useState } from "react";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
import LazyLoad from "react-lazyload";

const Olympiads = () => {
  const homeMenu = [
    { label: "Awards & Achievements", link: "/awardsAcheivements" },
    {
      label: "Gallery",
      link: "/Gallery",
      subMenu: [
        { label: "Photo Gallery", link: "/Gallery" },
        { label: "Video Gallery", link: "/VideoGallery" },
      ],
    },
    {
      label: "Careers",
      link: "/careers-openings",
      subMenu: [{ label: "Philosophy", link: "/philosophy" }],
    },
    { label: "School Calendar", link: "/calender" },
    {
      label: "Alumni",
      link: "",
      subMenu: [
        { label: "Admissions", link: "/admission" },
        { label: "Admissions IIT", link: "/admissionIIT" },
      ],
    },

    { label: "eMagazine", link: "/Magazine" },
    { label: "TAABIR Digital Dreams", link: "/digitaldreams" },
    {
      label: "CUET",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/CUET.pdf",
    },
  ];
  const [filterData, setFilterData] = useState("0");
  const filterYear = (value) => {
    setFilterData(value);
  };
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/admissions-banner.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Olympiads"
                breadEnd="Olympiads"
                breadMid="Olympiads"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="selection_list mb-4 float-end">
                <select
                  onChange={(e) => filterYear(e.target.value)}
                  className="p-2"
                >
                  <option value="0">Year 2022-2023</option>
                  <option value="1">Year 2021-2022</option>
                  <option value="2">Year 2020-2021</option>
                  <option value="3">Year 2019-2020</option>
                  <option value="4">Year 2018-2019</option>
                </select>
              </div>
              {filterData === "0" && (
                <div class="">
                  <div class="heading">
                    <h2>AUGMENTING KNOWLEDGE: OLYMPIADS 2022-2023</h2>
                  </div>
                  <div class="heading2 text-center">
                    <h4>NATIONAL SCIENCE OLYMPIAD (NSO)</h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2223-1.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td> AHAAN ARORA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRISHA KAPOOR </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NITYA SHRIVASTAVA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRISSHA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV GUPTA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VANNYA SINGH </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VANYA JAIN </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RIAAN MORRIS </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RAHI GUHA </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AVYUKT GUPTA </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SARAH SEHGAL </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHBIR SINGH </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV GARG </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANVITA GUPTA </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IVANA AGARWAL </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YUVAAN CHAWLA </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YUVIN GONUGUNTLA </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DARSH JANGRA </td>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinctio{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRAKRITI </td>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARCHIT AGARWAL </td>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADYAN RIZVI </td>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VEDANG BHARDWAJ </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMBAR VASHISHT </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VEDANJALI SHAH </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHRISHTI BANSAL </td>
                          <td> I </td>
                          <td> 7 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHBIR SINGH </td>
                          <td> II </td>
                          <td> 3 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> IVANA AGARWAL </td>
                          <td> II </td>
                          <td> 4 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> II </td>
                          <td> 4 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> ADVAITH ADARSH KURUP </td>
                          <td> II </td>
                          <td> 4 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> YUVIN GONUGUNTLA </td>
                          <td> II </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Rs. 1,000 + Zonal Bronze Medal + Certificate of
                            Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADYAN RIZVI </td>
                          <td> II </td>
                          <td> 5 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> AVIRAT CHOPRA </td>
                          <td> II </td>
                          <td> 6 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> SUMANYU SHARMA </td>
                          <td> II </td>
                          <td> 6 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> RACHIT RUSTAGI </td>
                          <td> II </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHRISHTI BANSAL </td>
                          <td> II </td>
                          <td> 7 </td>
                          <td>
                            {" "}
                            Rs. 1,000 + Zonal Bronze Medal + Certificate of
                            Zonal Excellence{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4>INTERNATIONAL MATH OLYMPIAD (IMO)</h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2223-2.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td> RYAAN GUPTA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Gold Medal +
                            Certificate of Outstanding Performance + Medal of
                            Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KIYAAN BHATIA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KHEVANSH BHATIA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NITYA SHRIVASTAVA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANSH MALIK </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MIRAYA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MEHAR SINGH ARORA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ABBIR AHLAWAT </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV GUPTA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Gold Medal +
                            Certificate of Outstanding Performance + Medal of
                            Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DAKSHH DHASMANA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RABJOT S GULIANI </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AYANSH MAHESHWARI </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VANYA JAIN </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAGAR SINGH </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ALINA BHARDWAJ </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AVYAN SONI </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RIAAN MORRIS </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Silver Medal
                            + Certificate of Outstanding Performance + Medal of
                            Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VANYA ARORA </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SANAY JAIN </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AAROHI SINGH </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VEDANT GARG </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHBIR SINGH </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV GARG </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMYRA MEHTA </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAIRA RAHEJA </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AGRIM DEWAN </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DIVYAM GIRI </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAMKIT JAIN </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VEER GULIANI </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADDYA GUPTA </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MYRA KHURANA </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SATWIK GUPTA </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA CHADDHA </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YUVIN GONUGUNTLA </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN GUPTA </td>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRITIKA GUPTA </td>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NETANYA SETHI </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> JIVANSH NANGRU </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHIYA GARG </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAARAV AGGARWAL </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITWICK AGARWAL </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DIVIJ ARORA </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VEDANG BHARDWAJ </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA PATNAIK </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMBAR VASHISHT </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARAV AGGARWAL </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RACHIT RUSTAGI </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RAGHAV ARORA </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMYRA MEHTA </td>
                          <td> II </td>
                          <td> 3 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> SIDDHANT MAMTANI </td>
                          <td> II </td>
                          <td> 3 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> SAMKIT JAIN </td>
                          <td> II </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Rs. 1,250 + Zonal Silver Medal + Certificate of
                            Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VEER GULIANI </td>
                          <td> II </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IVANA AGARWAL </td>
                          <td> II </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SUVIKRAM SINGH </td>
                          <td> II </td>
                          <td> 4 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            <strong>EKAANSH AGARWAL</strong>{" "}
                          </td>
                          <td>
                            {" "}
                            <strong>II</strong>{" "}
                          </td>
                          <td>
                            {" "}
                            <strong>6</strong>{" "}
                          </td>
                          <td>
                            {" "}
                            <strong>
                              Rs. 8,333+ International Gold Medal + Certificate
                              of Outstanding Performance
                            </strong>{" "}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            <strong>RACHIT RUSTAGI</strong>{" "}
                          </td>
                          <td>
                            {" "}
                            <strong>II</strong>{" "}
                          </td>
                          <td>
                            {" "}
                            <strong>6</strong>{" "}
                          </td>
                          <td>
                            {" "}
                            <strong>
                              Gifts Worth Rs. 1000/- + International Bronze
                              Medal + Certificate of Outstanding Performance
                            </strong>{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHRISHTI BANSAL </td>
                          <td> II </td>
                          <td> 7 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> VIDHI VASHISTH </td>
                          <td> II </td>
                          <td> 9 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4>INTERNATIONAL GENERAL KNOWLEDGE OLYMPIAD (IGKO)</h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2223-3.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td> AARAV GUPTA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHBIR SINGH </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRISHA BAJPAI </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Gold Medal +
                            Certificate of Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SATWIK GUPTA </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Rs. 1,000 + Zonal Bronze Medal + Certificate of
                            Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YUVAAN CHAWLA </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4>INTERNATIONAL ENGLISH OLYMPIAD (IEO)</h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2223-4.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>
                  <div class="table">
                    MIRAYA AARAV GUPTA YASHVI SINGH MYRA SETHI AVYAAN KOTA
                    ATHARV BANSAL VANYA JAIN ARAINA CHUGH AVYAN SONI DIVIT ARORA
                    PARAM S TATAVARTHY ATEEKSH CHAWLA RAHI GUHA VANYA ARORA
                    MAIRAA SINGH SARAH SEHGAL ARSHBIR SINGH SIMAR SINGH ANSHIKA
                    GUPTA AGRIM DEWAN AVYAN SHARMA AVYAAN KURAL DIVYAM GIRI
                    EKANSH BAHL ANAIRA GOEL MISHIKA VERMA IVAAN SHARMA PAARTH
                    SINGLA SWASTI MITTAL ANVITA GUPTA BHOMYA SHARMA RISHAAN
                    GUPTA VANSHIKA BALLABH IVANA AGARWAL REYANSHI AGARWAL RIAAN
                    CHUGH SHTAKSHI AGNIHOTRI MYRA KHANDELWAL ARHAM JAIN NAIRA
                    SWAROOP LAVANYA AGRAWAL RIDIT SINGLA ADVAY BANSAL
                    YASHVARDHAN KALRA ATIKSHA SHARMA ANYA BISHT ARTHAK SHUKLA
                    YUVAAN CHAWLA DHRUV BABBAR TOSHANNIE SETIA ADVAITH ADARSH
                    KURUP NAYSHA SATIJA YUVIN GONUGUNTLA ANSH CHAWLA KIARA JAI
                    PRAKASH AVIKA KHURANA NAVYA SHETTY AARAV SHARMA AADIT SINGH
                    CHAITANYA SRIVASTAVA NETANYA SETHI ARSHIYA GARG JAYANTIKA
                    BHATTACHARJYA SUMANYU SHARMA IDA SINGH VIVAAN KUNAL RANGOLE
                    EKAANSH AGARWAL ADITYA PATNAIK RACHIT RUSTAGI VIR NIJHAWAN
                    TANISHA GUPTA NANDIKA GUPTA VIVAAN KAMBOJ AARYA MEHROTRA
                    AVNI SINGH ARJUN ARORA TASHVI VIRMANI ANIRUDDHA BHATTACHARYA
                    NISHIKA MANINI SIMONE KAUR MAKKUR HANEEKA MODI AARAV SINHA
                    KHUSHI JOSHI AANYA SAHANI HITANSHI AGGARWAL NAVELI SHARMA
                    JHANVI L JALAN SARA GUPTA MYRA KAILWOO AISHIKA CHADHA SUHANI
                    SHARMA ARSHIA KATOCH EKUS SINGH KHOSLA ANSHIKA GUPTA EKANSH
                    BAHL ANVITA GUPTA YASHVARDHAN KALRA ADVAITH ADARSH KURUP
                    AARTI MIGLANI AADIT SINGH MD ADYAN RIZVI EKAANSH AGARWAL
                    ADITYA PATNAIK AARAV KHANDPUR SHRISHTI BANSAL GARVIT SINGHAL
                    AARAV SINHA NAVELI SHARMA ARSHIA KATOCH{" "}
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Gold Medal +
                            Certificate of Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + Zonal Gold Medal +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + Zonal Gold Medal +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + Zonal Gold Medal +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Gold Medal +
                            Certificate of Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Bronze Medal
                            + Certificate of Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Gold Medal +
                            Certificate of Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 7 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 8 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 8 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 8 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 8 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 8 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 8 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 9 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 9 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 9 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 9 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 9 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 9 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 9 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 9 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 10 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 10 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 10 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 10 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 10 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 10 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 10 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 12 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> I </td>
                          <td> 12 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 3 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 3 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 4 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 4 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 5 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 5 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 6 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Rs. 50,000+ International Gold Medal + Certificate
                            of Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 7 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 8 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 9 </td>
                          <td>
                            {" "}
                            Rs. 2,500 + Zonal Silver Medal + Certificate of
                            Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 10 </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> II </td>
                          <td> 12 </td>
                          <td>
                            {" "}
                            Rs. 2,500 + Zonal Silver Medal + Certificate of
                            Zonal Excellence{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4>
                      INTERNATIONAL SOICIAL STUDIES OLYMPIAD (ISSO)/
                      INTERNATIONAL COMMERCE OLYMPIAD (ICO)
                    </h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2223-5.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td> ARSHBIR SINGH </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKANSH BAHL </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHERYL MAHAJAN </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAN MEHTA </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IVANA AGARWAL </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Bronze Medal
                            + Certificate of Outstanding Performance + Medal of
                            Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSHI AGARWAL </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YUVAAN CHAWLA </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Gold Medal +
                            Certificate of Outstanding Performance + Medal of
                            Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YUVIN GONUGUNTLA </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Gold Medal +
                            Certificate of Outstanding Performance + Medal of
                            Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN GUPTA </td>
                          <td> 1 </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ATHARVA SINGH </td>
                          <td> 1 </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV SHARMA </td>
                          <td> 1 </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHIYA GARG </td>
                          <td> 1 </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Rs. 625 + Zonal Silver Medal + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4>NATIONAL CYBER OLYMPIAD (NCO)</h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2223-6.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td> VIVAAN AGARWAL </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Bronze Medal
                            + Certificate of Outstanding Performance + Medal of
                            Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAANVI ANAND </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRISSHA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RIHANSH KUKREJA </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Rs. 1,250 + Zonal Silver Medal + Certificate of
                            Zonal Excellence + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VANNYA SINGH </td>
                          <td> I </td>
                          <td> 1 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RIYAAN BEDI AHMED </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VANYA JAIN </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHIYA PODDAR </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RIAAN MORRIS </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Gold Medal +
                            Certificate of Outstanding Performance + Medal of
                            Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DEVSMITA NEGI </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Rs. 1,250 + Zonal Gold Medal + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAAN SRIVASTAVA </td>
                          <td> I </td>
                          <td> 2 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHBIR SINGH </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> HRIDAY MANDOWRA </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV GARG </td>
                          <td> I </td>
                          <td> 3 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of
                            Zonal{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SIBANI JAIN </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RISHAAN GUPTA </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + International Bronze Medal
                            + Certificate of Outstanding Performance + Medal of
                            Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAIYAM NAGPAL </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IVANA AGARWAL </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Rs. 2,500 + Zonal Silver Medal + Certificate of
                            Zonal Excellence + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANVAY GOYAL </td>
                          <td> I </td>
                          <td> 4 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV SHARMA </td>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANYA ARYA </td>
                          <td> I </td>
                          <td> 5 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHIYA GARG </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Rs. 2,500 + Zonal Silver Medal + Certificate of
                            Zonal Excellence + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAAN JAIN </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARAV AGGARWAL </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + Medal of Distinction +
                            Certificate of Distinction + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RACHIT RUSTAGI </td>
                          <td> I </td>
                          <td> 6 </td>
                          <td>
                            {" "}
                            Rs. 500 + Zonal Bronze Medal + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHRISHTI BANSAL </td>
                          <td> I </td>
                          <td> 7 </td>
                          <td>
                            {" "}
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {filterData === "1" && (
                <div class="">
                  <div class="heading text-center">
                    <h2>AUGMENTING KNOWLEDGE: OLYMPIADS 2021-2022 </h2>
                  </div>
                  <div class="heading2 text-center">
                    <h4>NATIONAL SCIENCE OLYMPIAD (NSO)</h4>
                  </div>

                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2122-1.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>

                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>GRADE</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td>ILISHA AGRAWAL </td>
                          <td>I </td>
                          <td>I</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 495 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td> VEDANT SINGH </td>
                          <td>I</td>
                          <td> I</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 568 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>VIHAAN SRIVASTAVA</td>
                          <td> I </td>
                          <td>I</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 596 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>AAYANSH AGARWAL </td>
                          <td>I</td>
                          <td>II</td>
                          <td>
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 116 +
                            Medal of Distinction + Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>ARSHBIR SINGH</td>
                          <td>I</td>
                          <td>II</td>
                          <td>
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 3 +
                            International Bronze Medal + Certificate of
                            Outstanding Performance
                          </td>
                        </tr>

                        <tr>
                          <td>ADVAITH ADARSH KURUP </td>
                          <td>I</td>
                          <td>III</td>
                          <td>
                            INTERNATIONAL RANK 36 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>ANVAY GOYAL </td>
                          <td>I</td>
                          <td>III</td>
                          <td>
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 10 +
                            Medal of Distinction + Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>DHRUV BABBAR </td>
                          <td>I</td>
                          <td>III</td>
                          <td>
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance
                          </td>
                        </tr>

                        <tr>
                          <td>IVANA AGARWAL</td>
                          <td> I</td>
                          <td>III</td>
                          <td>
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 3 +
                            International Bronze Medal + Certificate of
                            Outstanding Performance
                          </td>
                        </tr>

                        <tr>
                          <td>JAI DUA </td>
                          <td>I</td>
                          <td>III</td>
                          <td>
                            INTERNATIONAL RANK 22 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>LAVANYA AGRAWAL </td>
                          <td>I</td>
                          <td>III</td>
                          <td>
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 6 +
                            Zonal Silver Medal + Certificate of Zonal Excellence
                          </td>
                        </tr>

                        <tr>
                          <td>SIDDHI MANOCHA </td>
                          <td>I</td>
                          <td>III</td>
                          <td>
                            INTERNATIONAL RANK 37 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>YASHVARDHAN KALRA </td>
                          <td>I</td>
                          <td>III</td>
                          <td>
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 6 +
                            Zonal Silver Medal + Certificate of Zonal Excellence
                          </td>
                        </tr>

                        <tr>
                          <td>YUVAAN CHAWLA</td>
                          <td> I</td>
                          <td>III</td>
                          <td>
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 14 +
                            Medal of Distinction + Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>YUVAAN RANJAN </td>
                          <td>I</td>
                          <td>III</td>
                          <td>
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 14 +
                            Medal of Distinction + Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>YUVIN GONUGUNTLA </td>
                          <td>I</td>
                          <td>III</td>
                          <td>
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 7 +
                            Zonal Bronze Medal + Certificate of Zonal Excellence
                          </td>
                        </tr>

                        <tr>
                          <td>AANYA SHARMA </td>
                          <td>I </td>
                          <td>IV </td>
                          <td>
                            INTERNATIONAL RANK 36 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>ADVICK DUA </td>
                          <td>I</td>
                          <td>IV</td>
                          <td>
                            INTERNATIONAL RANK 36 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>ARCHIT AGARWAL </td>
                          <td>I</td>
                          <td>IV</td>
                          <td>
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance
                          </td>
                        </tr>

                        <tr>
                          <td>SAANVI KHAMESRA </td>
                          <td>I</td>
                          <td>IV </td>
                          <td>
                            INTERNATIONAL RANK 38 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>
                        <tr>
                          <td>TANISHKA BANSAL </td>
                          <td>I </td>
                          <td>IV </td>
                          <td>
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 6 +
                            Zonal Silver Medal + Certificate of Zonal Excellence
                          </td>
                        </tr>

                        <tr>
                          <td>VIVAAN GUPTA </td>
                          <td>I </td>
                          <td>IV </td>
                          <td>
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 10 +
                            Medal of Distinction + Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>ARSHIYA GARG </td>
                          <td>I </td>
                          <td>V </td>
                          <td>
                            INTERNATIONAL RANK 26 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>RITWICK AGARWAL </td>
                          <td>I </td>
                          <td>V </td>
                          <td>
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 8 +
                            Zonal Silver Medal + Certificate of Zonal Excellence
                          </td>
                        </tr>

                        <tr>
                          <td>SUMANYU SHARMA</td>
                          <td> I </td>
                          <td>V </td>
                          <td>
                            INTERNATIONAL RANK 56 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>SHAURYA ARORA </td>
                          <td> I </td>
                          <td>VII </td>
                          <td>
                            INTERNATIONAL RANK 72 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>VIDHI VASHISTH </td>
                          <td>I </td>
                          <td>VIII </td>
                          <td>
                            INTERNATIONAL RANK 54 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>

                        <tr>
                          <td>SIDDHARTH MISHRA</td>
                          <td> I </td>
                          <td>XII</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 132 + Medal of Distinction +
                            Certificate of Distinction
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="heading2 text-center">
                    <h4>INTERNATIONAL MATH OLYMPIAD (IMO)</h4>
                  </div>

                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2122-2.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>

                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>GRADE</th>
                          <th>AWARD WON</th>
                        </tr>

                        <tr>
                          <td> AHAAN MADAN </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1+
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHBIR SINGH </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 61 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANANDITA VIKAS BANSAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 24 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADVAITH ADARSH KURUP </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANVAY GOYAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 14 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 4 +
                            Zonal Gold Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IVANA AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KRISHA SINGLA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> LAVANYA AGRAWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 8 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAISHA KAPOOR </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH GOGIA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 2 +
                            International Silver Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RIAAN CHUGH </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 16 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RISHAAN GUPTA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 20 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAANVI SAINI </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 11 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA CHADHA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 2 +
                            International Silver Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SIBANI JAIN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 2 +
                            International Silver Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SIDDHI MANOCHA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 5 +
                            Zonal Silver Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHVARDHAN KALRA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YUVAAN CHAWLA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AADVIK GUPTA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 4 +
                            Zonal Gold Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAVYA SHETTY </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 16 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRITIKA GUPTA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 5 +
                            Zonal Silver Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAANVI KHAMESRA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TANISHKA BANSAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA PATNAIK </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 30 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMBAR VASHISTH </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 4 +
                            Zonal Gold Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHIYA GARG </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 8 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RACHIT RUSTAGI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SUMANYU SHARMA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VEDANG BHARDWAJ </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 27 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAN KHURANA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 2 +
                            International Silver Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARUSH DEWAN </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 26 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANYA MUNDRA </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 8 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHRISHTI BANSAL </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 4 +
                            Zonal Gold Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA ARORA </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TIYA GUPTA </td>
                          <td> I </td>
                          <td> XII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 115 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4>INTERNATIONAL GENERAL KNOWLEDGE OLYMPIAD (IGKO)</h4>
                  </div>

                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2122-3.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>GRADE</th>
                          <th>AWARD WON</th>
                        </tr>

                        <tr>
                          <td> AYANSH MAHESHWARI </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 429 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAMKIT JAIN </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 24 +
                            Zonal Silver Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANANDITA VIKAS BANSAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 11 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANVAY GOYAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 44 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARAV MEHROTRA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 20 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARTHAK SHUKLA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 43 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DHRUV SARIN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 38 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RUDRAKSH SINGH </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 21 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA CHADHA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 3 +
                            International Bronze Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHVARDHAN KALRA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 24 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KRITIKA VASHISHTH </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 9 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAANVI KHAMESRA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHIKA AGGARWAL </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 71 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAN KHURANA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 64 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARUSH DEWAN </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 69 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHIVANGI TALWAR </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 83 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AYANNA VAIDYA </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 13 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> BHAVYA GUPTA </td>
                          <td> I </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 29 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4>INTERNATIONAL ENGLISH OLYMPIAD (IEO)</h4>
                  </div>

                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2122-4.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>

                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>GRADE</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td> RIYANA MALHOTRA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 220 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AAYANSH AGARWAL </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 318 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MISHIKA VERMA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 332 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANYA ARORA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1+
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AASHVIE BHATNAGAR </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 3 +
                            International Bronze Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADVAITH ADARSH KURUP </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 21 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARNAV BHARDWAJ </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 15 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 9 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> JATIN SHARMA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 20 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> LAVANYA AGRAWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MAIRA SETIA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 3 +
                            International Bronze Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NATALYA ALREJA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 20 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PAHAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RIDIT SINGLA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RUDRAKSH SINGH </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA CHADHA </td>
                          <td> </td>
                          <td> </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 15 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SIBANI JAIN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 4 +
                            Zonal Gold Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SIDDHI MANOCHA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 9 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHVARDHAN KALRA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 4 +
                            Zonal Gold Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YUVAAN RANJAN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 3 +
                            International Bronze Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AADIT SINGH </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV SHARMA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 23 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AKSHAT ROY CHOWDHURY </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ALISHA CHAUDHRY </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 7 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARCHIT AGARWAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 6 +
                            Zonal Bronze Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AVIKA KHURANA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AVYA JINDAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> GAURI KHANNA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 20 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> GIANNA SINGH </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 24 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IRA AWASTHI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 14 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KRITIKA VASHISHTH </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 4 +
                            Zonal Gold Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MD. ADYAN RIZVI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MIHIRA DAS </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 11 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAISHA BOTHRA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 14 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAVYA SHETTY </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 9 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRAKRITI SINGH </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAANVI KHAMESRA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 5 +
                            Zonal Silver Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TANISHKA BANSAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 4 +
                            Zonal Gold Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARUNIMA SHARMA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 9 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 34 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAUNIDH SETTHEE </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 8 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NIMISHA SINGH </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 30 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RACHIT RUSTAGI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 30 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAN KHURANA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YAGN GUPTA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 5 +
                            Zonal Silver Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AKSHAYNI MATHUR </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 10 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMOGH DOSHI </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ATHARV MALHOTRA </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 37 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KAAVYA JOSHI </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 28 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHIT RASTOGI </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 11 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MAYAN BHASKAR </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 20 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NEHAL SOTHWAL </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 31 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHIVANGI TALWAR </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SOHANA SINGH </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 6 +
                            Zonal Silver Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARYA MEHROTRA </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV SINHA </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 28 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AHAAN PORWAL </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 3 +
                            International Bronze Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> HANEEKA MODI </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 8 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KHUSHI JOSHI </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 8 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SMAHI VIJAY </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 8 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN BANERJEE </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 27 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARINJAY JAIN </td>
                          <td> I </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 38 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> BHAVYA GUPTA </td>
                          <td> I </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 27 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> GARGI ROY </td>
                          <td> I </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 6 +
                            Zonal Bronze Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TEJAL DOSHI </td>
                          <td> I </td>
                          <td> X </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 19 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MIHEEKA BHASIN </td>
                          <td> I </td>
                          <td> XI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 44 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TIYA GUPTA </td>
                          <td> I </td>
                          <td> XII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 69 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHITA AGARWAL </td>
                          <td> I </td>
                          <td> XII </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 16 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="heading2 text-center">
                    <h4>NATIONAL CYBER OLYMPIAD (NCO)</h4>
                  </div>

                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2122-5.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>

                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>GRADE</th>
                          <th>AWARD WON</th>
                        </tr>

                        <tr>
                          <td> RIYAAN BEDI AHMED </td>
                          <td> RIYAAN BEDI AHMED </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 222 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AAYANSH AGARWAL </td>
                          <td> AAYANSH AGARWAL </td>
                          <td> II </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 2 +
                            International Silver Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AYAAN JULKA </td>
                          <td> AYAAN JULKA </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 447 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARNAV ARORA </td>
                          <td> AARNAV ARORA </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANVAY GOYAL </td>
                          <td> ANVAY GOYAL </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 5 +
                            Zonal Gold Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARAV MEHROTRA </td>
                          <td> ARAV MEHROTRA </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 20 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARNAV BHARDWAJ </td>
                          <td> ARNAV BHARDWAJ </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 20 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARTHAK SHUKLA </td>
                          <td> ARTHAK SHUKLA </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 28 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> DHRUV BABBAR </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 5 +
                            Zonal Gold Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IVANA AGARWAL </td>
                          <td> IVANA AGARWAL </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 5 +
                            Zonal Gold Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH GOGIA </td>
                          <td> REYANSH GOGIA </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 19 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAIYAM NAGPAL </td>
                          <td> SAIYAM NAGPAL </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SATWIK GUPTA </td>
                          <td> SATWIK GUPTA </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 10 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA CHADHA </td>
                          <td> SHAURYA CHADHA </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 28 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SIBANI JAIN </td>
                          <td> SIBANI JAIN </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 10 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHVARDHAN KALRA </td>
                          <td> YASHVARDHAN KALRA </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + + INTERNATIONAL RANK 10 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YUVIN GONUGUNTLA </td>
                          <td> YUVIN GONUGUNTLA </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 28 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANYA ARYA </td>
                          <td> AANYA ARYA </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 23 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARCHIT AGARWAL </td>
                          <td> ARCHIT AGARWAL </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 37 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AROHI BEEJAWAT </td>
                          <td> AROHI BEEJAWAT </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 8 + Medal
                            of Distinction + Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KRITIKA VASHISHTH </td>
                          <td> KRITIKA VASHISHTH </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 27 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAANVI KHAMESRA </td>
                          <td> SAANVI KHAMESRA </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 37 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHANAYA AGGARWAL </td>
                          <td> SHANAYA AGGARWAL </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 26 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN GUPTA </td>
                          <td> VIVAAN GUPTA </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 24 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHIYA GARG </td>
                          <td> ARSHIYA GARG </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 17 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> EKAANSH AGARWAL </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 30 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RACHIT RUSTAGI </td>
                          <td> RACHIT RUSTAGI </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 24 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITWICK AGARWAL </td>
                          <td> RITWICK AGARWAL </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 17 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAN KHURANA </td>
                          <td> VIHAN KHURANA </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 17 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MAYAN BHASKAR </td>
                          <td> MAYAN BHASKAR </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 31 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="heading2 text-center">
                    <h4>INTERNATIONAL SOCIAL STUDIES OLYMPIAD (ISSO)</h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2122-6.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>GRADE</th>
                          <th>AWARD WON</th>
                        </tr>

                        <tr>
                          <td> ANVAY GOYAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 33 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKANSH JAIN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 24 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IVANA AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RUDRAKSH SINGH </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 2 +
                            International Silver Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SATWIK GUPTA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 6 +
                            Zonal Bronze Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA CHADHA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 11 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SIBANI JAIN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 6 +
                            Zonal Bronze Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHVARDHAN KALRA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 1 +
                            International Gold Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YUVIN GONUGUNTLA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 11 +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAANVI KHAMESRA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 15 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 27 + Medal of Distinction +
                            Certificate of Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITWICK AGARWAL </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 2 +
                            International Silver Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YAGN GUPTA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + INTERNATIONAL RANK 4 +Zonal
                            Gold Medal + Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="heading2 text-color">
                    <h4>INTERNATIONAL COMMERCE OLYMPIAD (ICO)</h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2122-7.webp"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>

                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>GRADE</th>
                          <th>AWARD WON</th>
                        </tr>

                        <tr>
                          <td> ARYAN KAPOOR </td>
                          <td> I </td>
                          <td> XI </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 500/- + INTERNATIONAL RANK 42 +
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHITA AGARWAL </td>
                          <td> I </td>
                          <td> XII </td>
                          <td>
                            {" "}
                            Rs. 6,250+ INTERNATIONAL RANK 4 + Medal of
                            Distinction + Certificate of Outstanding
                            Performance{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="heading2 text-center">
                    <h4>AUGMENTING KNOWLEDGE: IBT MAINS 2021-2022</h4>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th colspan="4">Certificate of Honour</th>
                        </tr>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>GRADE</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td> AMBAR VASHISTH </td>
                          <td> V </td>
                          <td> V </td>
                          <td> Certificate of Honour for Reasoning </td>
                        </tr>
                        <tr>
                          <td> MISHKA MENGHANI </td>
                          <td> V </td>
                          <td> V </td>
                          <td> Certificate of Honour for English </td>
                        </tr>
                        <tr>
                          <td> SVANIK GHAI </td>
                          <td> V </td>
                          <td> V </td>
                          <td> Certificate of Honour for Mathematics </td>
                        </tr>
                        <tr>
                          <td> VIDHI VASHISTH </td>
                          <td> VIII </td>
                          <td> VIII </td>
                          <td> Certificate of Honour for Reasoning </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th colspan="4">Certificate of High Distinction</th>
                        </tr>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>GRADE</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td>ADVAITH ADARSH KURUP</td>
                          <td>III</td>
                          <td> III </td>
                          <td>Certificate of High Distinction for Science</td>
                        </tr>
                        <tr>
                          <td>AMBAR VASHISTH</td>
                          <td>V </td>
                          <td>V </td>
                          <td>Certificate of High Distinction for English</td>
                        </tr>
                        <tr>
                          <td>AMBAR VASHISTH</td>
                          <td>V</td>
                          <td> V </td>
                          <td>Certificate of High Distinction for Science</td>
                        </tr>
                        <tr>
                          <td>ARSHIYA GARG</td>
                          <td>V </td>
                          <td>V </td>
                          <td>Certificate of High Distinction for English</td>
                        </tr>
                        <tr>
                          <td>ARSHIYA GARG</td>
                          <td>V </td>
                          <td>V </td>
                          <td>
                            Certificate of High Distinction for Mathematics
                          </td>
                        </tr>
                        <tr>
                          <td>ARSHIYA GARG</td>
                          <td>V </td>
                          <td>V </td>
                          <td>Certificate of High Distinction for Reasoning</td>
                        </tr>
                        <tr>
                          <td>ARSHIYA GARG</td>
                          <td>V</td>
                          <td> V </td>
                          <td>Certificate of High Distinction for Science</td>
                        </tr>
                        <tr>
                          <td>ASYA BANSAL</td>
                          <td>V </td>
                          <td>V </td>
                          <td>Certificate of High Distinction for Science</td>
                        </tr>
                        <tr>
                          <td>MISHKA MENGHANI</td>
                          <td>V </td>
                          <td>V </td>
                          <td>
                            Certificate of High Distinction for Mathematics
                          </td>
                        </tr>
                        <tr>
                          <td>MISHKA MENGHANI</td>
                          <td>V</td>
                          <td> V </td>
                          <td>Certificate of High Distinction for Science</td>
                        </tr>
                        <tr>
                          <td>RISHIKA SACHDEVA</td>
                          <td>V</td>
                          <td> V </td>
                          <td>
                            Certificate of High Distinction for Mathematics
                          </td>
                        </tr>
                        <tr>
                          <td>SIDDHARTH BANSAL</td>
                          <td>V </td>
                          <td>V </td>
                          <td>Certificate of High Distinction for English</td>
                        </tr>
                        <tr>
                          <td>SVANIK GHAI</td>
                          <td>V</td>
                          <td> V </td>
                          <td>Certificate of High Distinction for English</td>
                        </tr>
                        <tr>
                          <td>SVANIK GHAI</td>
                          <td>V</td>
                          <td> V </td>
                          <td>Certificate of High Distinction for Reasoning</td>
                        </tr>
                        <tr>
                          <td>AASHVI THAKUR</td>
                          <td>VI </td>
                          <td>VI </td>
                          <td>
                            Certificate of High Distinction for Mathematics
                          </td>
                        </tr>
                        <tr>
                          <td>UTKARSHIKA RAJPUT</td>
                          <td>VII </td>
                          <td>VII </td>
                          <td>Certificate of High Distinction for English</td>
                        </tr>
                        <tr>
                          <td>AANYA MITTAL</td>
                          <td>VIII </td>
                          <td>VIII </td>
                          <td>
                            Certificate of High Distinction for Mathematics
                          </td>
                        </tr>
                        <tr>
                          <td>AARAV SINHA</td>
                          <td>VIII </td>
                          <td>VIII </td>
                          <td>Certificate of High Distinction for English</td>
                        </tr>
                        <tr>
                          <td>AARAV SINHA</td>
                          <td>VIII</td>
                          <td> VIII </td>
                          <td>
                            Certificate of High Distinction for Mathematics
                          </td>
                        </tr>
                        <tr>
                          <td>NAVNOOR KAUR</td>
                          <td>VIII </td>
                          <td>VIII </td>
                          <td>
                            Certificate of High Distinction for Mathematics
                          </td>
                        </tr>
                        <tr>
                          <td>SHOBIT GALHOTRA</td>
                          <td>VIII</td>
                          <td> VIII </td>
                          <td>Certificate of High Distinction for English</td>
                        </tr>
                        <tr>
                          <td>SIMONE KAUR MAKKUR</td>
                          <td>VIII </td>
                          <td>VIII </td>
                          <td>
                            Certificate of High Distinction for Mathematics
                          </td>
                        </tr>
                        <tr>
                          <td>SIMONE KAUR MAKKUR</td>
                          <td>VIII</td>
                          <td> VIII </td>
                          <td>Certificate of High Distinction for Reasoning</td>
                        </tr>
                        <tr>
                          <td>SIMONE KAUR MAKKUR</td>
                          <td>VIII </td>
                          <td>VIII </td>
                          <td>Certificate of High Distinction for Science</td>
                        </tr>
                        <tr>
                          <td>VIDHI VASHISTH</td>
                          <td>VIII</td>
                          <td> VIII </td>
                          <td>
                            Certificate of High Distinction for Mathematics
                          </td>
                        </tr>
                        <tr>
                          <td>VIDHI VASHISTH</td>
                          <td>VIII </td>
                          <td>VIII </td>
                          <td>Certificate of High Distinction for Science</td>
                        </tr>
                        <tr>
                          <td>MAMILLA SAI ROHAN</td>
                          <td>IX</td>
                          <td> IX </td>
                          <td>Certificate of High Distinction for English</td>
                        </tr>
                        <tr>
                          <td>MAMILLA SAI ROHAN</td>
                          <td>IX</td>
                          <td> IX </td>
                          <td>Certificate of High Distinction for Reasoning</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {filterData === "2" && (
                <div class="">
                  <div class="heading2">
                    <h4>AUGMENTING KNOWLEDGE: OLYMPIADS (2020-2021) </h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2021-1.webp"
                        width="100%"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>

                  <div class="heading2 text-center">
                    <h4>NATIONAL SCIENCE OLYMPIAD (NSO)</h4>
                  </div>

                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td>ARSHBIR SINGH </td>
                          <td>I</td>
                          <td>I</td>
                          <td>
                            INTERNATIONAL RANK 353 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>YASHVARDHAN KALRA </td>
                          <td>I</td>
                          <td>II</td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 12 +
                            ZONAL GOLD MEDAL + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>ARNAV BHARDWAJ</td>
                          <td> I</td>
                          <td>II</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 612 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>SIBANI JAIN </td>
                          <td>I </td>
                          <td>II </td>
                          <td>
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 73 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>SHIVIKA BEHL </td>
                          <td>I </td>
                          <td>III </td>
                          <td>
                            INTERNATIONAL RANK 14 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>ASHNOOR BHATIA</td>
                          <td> I</td>
                          <td></td>
                          <td>
                            III GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 11 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>ADVAITA BOSE </td>
                          <td>I</td>
                          <td> I </td>
                          <td>
                            INTERNATIONAL RANK 290 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>MANIT JAIN </td>
                          <td>I </td>
                          <td>III </td>
                          <td>
                            INTERNATIONAL RANK 23 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>SAANVI KHAMESRA</td>
                          <td> I </td>
                          <td>III </td>
                          <td>
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 7 + MEDAL
                            OF DISTINCTION + CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>AADVIK GUPTA </td>
                          <td>I </td>
                          <td>III </td>
                          <td>
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 2 +
                            INTERNATIONAL SILVER MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE
                          </td>
                        </tr>
                        <tr>
                          <td>RACHIT RUSTAGI</td>
                          <td> I </td>
                          <td>IV </td>
                          <td>
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 12 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>EKAANSH AGARWAL</td>
                          <td> I </td>
                          <td>IV </td>
                          <td>
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 12 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>AMBAR VASHISTH</td>
                          <td> I</td>
                          <td> IV </td>
                          <td>
                            INTERNATIONAL RANK 27 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>SHRISHTI BANSAL</td>
                          <td> I</td>
                          <td> V </td>
                          <td>
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 6 +
                            ZONAL SILVER MEDAL + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>ISHIT RASTOGI </td>
                          <td>I</td>
                          <td> VI</td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 19 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>AHAAN PORWAL </td>
                          <td>I </td>
                          <td>VII </td>
                          <td>
                            INTERNATIONAL RANK 33 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="heading2 text-center">
                    <h4>INTERNATIONAL MATH OLYMPIAD (IMO)</h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2021-2.webp"
                        width="100%"
                        className="img-fluid"
                        alt="Lotus Valley School, Gurgaon"
                      />
                    </LazyLoad>
                  </div>

                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>

                        <tr>
                          <td> VEER GULIANI </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 22 +
                            ZONAL GOLD MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAVYA GUPTA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 382 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH GOGIA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 119 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 80 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IVANA AGARWAL </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 183 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SPARSH JAIN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARYAN DEWAN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 16 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN ARORA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 31+ MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TANISHKA BANSAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 34 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KRISH NARANG </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 20 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KRITIKA VASHISHTH </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 6 +
                            ZONAL BRONZE MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANUSHA SRIVASTAVA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 32 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN GUPTA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 9 + MEDAL
                            OF DISTINCTION + CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VANYA YADAV </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 21 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADVICK DUA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 11 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAANVI KHAMESRA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 2 +
                            INTERNATIONAL SILVER MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAVYA SHETTY </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 24 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAVYA SHETTY </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 19 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANYA SHARMA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 6 +
                            ZONAL BRONZE MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AADVIK GUPTA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 3 +
                            INTERNATIONAL BRONZE MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAARAV AGGARWAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 4 +
                            ZONAL BRONZE MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA PATNAIK </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 9 + MEDAL
                            OF DISTINCTION + CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITWICK AGARWAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DIVIJ ARORA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 23 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAKSHAM MITTAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHIKA AGGARWAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 16 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RISHIT VIKASH </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 6 +
                            ZONAL BRONZE MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHIYA GARG </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AVIRAT CHOPRA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 9 + MEDAL
                            OF DISTINCTION + CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SUMANYU SHARMA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 10 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN KUNAL RANGOLE </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 6 +
                            ZONAL BRONZE MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NONITHA TALLURI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 4 +
                            ZONAL GOLD MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAN KHURANA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 6 +
                            ZONAL BRONZE MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VEDANG BHARDWAJ </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 16 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMBAR VASHISTH </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 4 +
                            ZONAL GOLD MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SVANIK GHAI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 3 +
                            INTERNATIONAL BRONZE MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RIDDHI GUPTA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 31 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHRISHTI BANSAL </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 6 +
                            ZONAL BRONZE MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA ARORA </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MAYAN BHASKAR </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 11 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARNAV JAIN </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SMAHI VIJAY </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 50 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AGASTYA TRIKHA </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 59 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRIYADARSHINI GHOSH </td>
                          <td> I </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 44 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AVIRAJ GOYLE </td>
                          <td> I </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 44 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AGRIM GUPTA </td>
                          <td> I </td>
                          <td> X </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 6 +
                            ZONAL SILVER MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> INHAAS VIRMANI </td>
                          <td> I </td>
                          <td> XI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 66 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="heading2 text-centwe">
                    <h4>INTERNATIONAL GENERAL KNOWLEDGE OLYMPIAD (IGKO)</h4>
                  </div>

                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2021-3.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2021-4.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table className="table-responsive" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>

                        <tr>
                          <td> YASHVARDHAN KALRA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 45 +
                            ZONAL SILVER MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RUDRAKSH SINGH </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 86
                            +ZONAL BRONZE MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA CHADHA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 574 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMAIRA VERMA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 21 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARYAN DEWAN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRITIKA GUPTA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 19 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ASHNOOR BHATIA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 10 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KRITIKA VASHISHTH </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 19 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MIHIRA DAS </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANUSHA SRIVASTAVA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 19 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARIA DIXIT </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 19 +MEDAL
                            OF DISTINCTION + CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAANVI KHAMESRA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 39 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITWICK AGARWAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 8 +
                            ZONAL BRONZE MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAUNIDH SETTHEE </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAAN VIDWANS </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 35 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2021-5.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads2021-6.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="table">
                    <table className="table-responsive" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>

                        <tr>
                          <td> PAARTH SINGLA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 234 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AHAAN MADAN </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 243 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAVYA GUPTA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 143 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHVARDHAN KALRA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 85 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RUDRAKSH SINGH </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 225 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VANSHIKA BALLABH </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 289 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMAIRA VERMA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV SHARMA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 11 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHIVIKA BEHL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 3 +
                            INTERNATIONAL BRONZE MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TANISHKA BANSAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 24 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRITIKA GUPTA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 4 +
                            ZONAL GOLD MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ASHNOOR BHATIA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MEGAN S THAKARE </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 3 +
                            INTERNATIONAL BRONZE MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MD. ADYAN RIZVI </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 27 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAAN SINGH </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 6 +
                            ZONAL BRONZE MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KRITIKA VASHISHTH </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARADHYA BATRA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 10 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MIHIRA DAS </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 24 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARCHIT AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 3 +
                            INTERNATIONAL BRONZE MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANUSHA SRIVASTAVA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 2 +
                            INTERNATIONAL SILVER MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VARTIKA GARG </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN GUPTA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 10 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARIA DIXIT </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANTARA INDRAYAN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAANVI KHAMESRA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 13 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AYAANSH DUA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RAYAANSH JAIN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AADITYA KAPUR </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 4 +
                            ZONAL GOLD MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA CHHABRA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA PATNAIK </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 10 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DEVYANI SINGH KAMBOJ </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITWICK AGARWAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 2 +
                            INTERNATIONAL SILVER MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 3 +
                            INTERNATIONAL BRONZE MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> CHESLIN GARG </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> JAYANTIKA BHATTACHARJYA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAISHA PODDAR </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 7 + MEDAL
                            OF DISTINCTION + CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YAGN GUPTA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ATHARV GUPTA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAUNIDH SETTHEE </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAN KHURANA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 9 + MEDAL
                            OF DISTINCTION + CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ASHVANT ROY </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SVANIK GHAI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 11+ MEDAL
                            OF DISTINCTION + CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ASHWIKA GUPTA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 4 +
                            ZONAL GOLD MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIR NIJHAWAN </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 4 +
                            ZONAL GOLD MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHIVANGI TALWAR </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 20 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHIT RASTOGI </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 10 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SOHANA SINGH </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 27 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANYA SAHANI </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 18 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> BHAVYA GUPTA </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 1 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TEJAL DOSHI </td>
                          <td> I </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 38 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAI MOHIT KOTTA </td>
                          <td> I </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DIVYANKA DIXIT </td>
                          <td> I </td>
                          <td> X </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 9 +
                            ZONAL BRONZE MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANANYA JAIN </td>
                          <td> I </td>
                          <td> XI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 48 + MEDAL OF DISTINCTION +
                            CERTIFICATE OF DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARCHIT SHARMA </td>
                          <td> I </td>
                          <td> XI </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 500/- + INTERNATIONAL RANK 22 +
                            MEDAL OF DISTINCTION + CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHITA AGARWAL </td>
                          <td> I </td>
                          <td> XI </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + INTERNATIONAL RANK 7 +
                            ZONAL BRONZE MEDAL + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="heading2 text-center">
                    <h4>LOTUS VALLEY LEARNERS WON LAURELS IN HINDI OLYMPIAD</h4>
                  </div>

                  <p>
                    Hindi Vikas Sansthan, Delhi organized the Hindi Olympiad on
                    21st August 2020. Lotus Valley International School, Gurgaon
                    students from classes IV- X participated in the test which
                    evaluated their knowledge of Vocabulary, Grammar, Subject
                    proficiency and knowledge of eminent literary figures of the
                    Hindi Language. Students participated in the Olympiad with
                    much zeal and vigor. It was evident in the result as the
                    students made the school proud with their outstanding
                    performance.
                  </p>
                  <p>
                    Yagan Gupta – Grade -IV received a special mention for
                    securing the{" "}
                    <strong>1st Position at the National Level </strong>honoured
                    with Baal Shresht trophy and certificate.{" "}
                  </p>
                  <p>
                    <strong>6 Students</strong> received Gold Medals (Vidisha
                    Shrivastav- Grade-VI , Aanya Sharma – Grade-III, Jivitesh
                    Yadav- Grade-III, Aradhya - Grade-III, Yagan Gupta-
                    Grade-IV, Arshia Garg-Grade-IV)
                  </p>
                  <p>
                    <strong>5</strong> Silver Medals (Vidyansh Kohli -Grade-X ,
                    Diya Gera – Grade-VII , Rudransh Singh -Grade -VII, Shradha
                    Miglani -Grade-VII, Mahira Kohali - Grade-VII)
                  </p>
                  <p>
                    <strong>1</strong> Bronze (Ritisha Mehrotra – Grade-IX){" "}
                  </p>
                </div>
              )}
              {filterData === "3" && (
                <div class="9">
                  <div class="heading">
                    <h4>AUGMENTING KNOWLEDGE: OLYMPIADS 2019-20</h4>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-1.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-2.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-3.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-4.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-5.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-6.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-7.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-8.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table">
                    <table border="1" width="100%">
                      <tbody>
                        <tr>
                          <th colspan="4">NATIONAL SCIENCE OLYMPIAD (NSO)</th>
                        </tr>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 51 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IVANA AGARWAL </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 19 + GIFTS WORTH Rs. 1000 + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARNAV ARORA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 40 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARCHIT AGARWAL </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 3 + GIFTS WORTH Rs. 1000 +
                            INTERNATIONAL BRONZE MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANYA ARYA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 15 + GIFTS WORTH Rs. 1000 + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAVYA SHETTY </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 3 + GIFTS WORTH Rs. 1000 +
                            INTERNATIONAL BRONZE MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AROHI BEEJAWAT </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 + GIFTS WORTH Rs. 1000 + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VANYA YADAV </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 7 + Rs. 1000 + ZONAL BRONZE MEDAL
                            + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AYAANSH DUA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 + GIFTS WORTH Rs. 1000 + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHIYA GARG </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 31+ MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMBAR VASHISTH </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 20 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITWICK AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 31+ MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DIVIJ ARORA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 5+ MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2 +MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 26 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA ARORA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 9 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHIT RASTOGI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 44 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> HANEEKA MODI </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 37 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIDHI VASHISTH </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 42 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> II </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA ARORA </td>
                          <td> II </td>
                          <td> V </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> ISHIT RASTOGI </td>
                          <td> II </td>
                          <td> V </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="heading2 text-center">
                    <h4>INTERNATIONAL ENGLISH OLYMPIAD (IEO)</h4>
                  </div>

                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-9.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-10.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td> IVANA AGARWAL </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2+ GIFTS WORTH Rs. 1000 +
                            INTERNATIONAL SILVER MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> LAVANYA SHARMA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 43 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> JATIN SHARMA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 31 + GIFTS WORTH Rs. 1000 + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YUVIN GONUGUNTLA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1+ GIFTS WORTH Rs. 1000 +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MEHER NIGAM </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1+ GIFTS WORTH Rs. 1000+
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSHI AGARWAL </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 44 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAANVI SAINI </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 37 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MAIRA SINGAL </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 55 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AISHA ARORA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 5 + GIFTS WORTH Rs. 1000 + ZONAL
                            GOLD MEDAL + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SEERAT JETLEY </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 15 + Rs. 1000 + ZONAL BRONZE
                            MEDAL + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RONAV PANDEY </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 51 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SIA PRASHANT BHANGUI </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MISHKA MENGHANI </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 23+ MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN KUNAL RANGOLE </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DEVYANI KAMBOJ </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 23 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA PATNAIK </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AVIRAJ AGARWAL </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 45 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> GARVIT SINGHAL </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 81 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHIVENN GUPTA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 61 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> JASMEH SODHI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 33 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TANISHKKA AGGARWAL </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 9 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NANDIKA GUPTA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 41 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KOVIDH SHARMA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 86 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHIT RASTOGI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 85 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANYA SAXENA </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANIRUDDHA BHATTACHARYA </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 57 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KHUSHI JOSHI </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AGASTYA TRIKHA </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 57 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AADYAA SAXENA </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 57 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANYA SAHANI </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHAAN CHHABRA </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 14 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TEJAL DOSHI </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 23 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAKSHAM JAIN </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 37 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANANYA SALUJA </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 35 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MAITHILI DUBEY </td>
                          <td> I </td>
                          <td> X </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 127 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA BALLABH </td>
                          <td> I </td>
                          <td> XII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 14 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRIYA BASIL </td>
                          <td> I </td>
                          <td> XII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 76 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMEYA ASHISH DEHADE </td>
                          <td> I </td>
                          <td> XII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 3 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> LEVEL II </td>
                          <td> </td>
                          <td> </td>
                          <td> </td>
                        </tr>
                        <tr>
                          <td> ANIKA BHARDWAJ </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 777 + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IDA SINGH </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 131 + GIFTS WORTH RS. 1000/- +
                            CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN KUNAL RANGOLE </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 343 + GIFTS WORTH RS. 1000/- +
                            CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DEVYANI SINGH KAMBOJ </td>
                          <td> II </td>
                          <td> III </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> ADITYA PATNAIK </td>
                          <td> II </td>
                          <td> III </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> AKSHAYNI MATHUR </td>
                          <td> II </td>
                          <td> IV </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> AVIRAJ AGARWAL </td>
                          <td> II </td>
                          <td> V </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> JASMEH SODHI </td>
                          <td> II </td>
                          <td> V </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> TANISHKKA AGGARWAL </td>
                          <td> II </td>
                          <td> V </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> HANEEKA MODI </td>
                          <td> II </td>
                          <td> VI </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> KHUSHI JOSHI </td>
                          <td> II </td>
                          <td> VI </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> MIHIKAA SINGH </td>
                          <td> II </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> II </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHAAN CHHABRA </td>
                          <td> II </td>
                          <td> VIII </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> YASHITA AGARWAL </td>
                          <td> II </td>
                          <td> X </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS. 1000/- + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TANVI ARORA </td>
                          <td> II </td>
                          <td> XI </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> NIHARIKA RAJPUT </td>
                          <td> II </td>
                          <td> XI </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> ARYAN JAIN </td>
                          <td> II </td>
                          <td> XI </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> ADITYA BALLABH </td>
                          <td> II </td>
                          <td> XII </td>
                          <td>
                            {" "}
                            RS. 1,000 + ZONAL BRONZE MEDAL + CERTIFICATE OF
                            ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMEYA ASHISH DEHADE </td>
                          <td> II </td>
                          <td> XII </td>
                          <td>
                            {" "}
                            RS. 10,000+ INTERNATIONAL BRONZE MEDAL + CERTIFICATE
                            OF OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-11.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="heading2 text-center">
                    <h4>INTERNATIONAL GENERAL KNOWLEDGE OLYMPIAD (IGKO)</h4>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>

                        <tr>
                          <td> AKSHAT SHARMA </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 21 + GIFTS WORTH Rs. 1000 + ZONAL
                            SILVER MEDAL + CERTIFICATE ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHAAN CHHABRA </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 295 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARCHIT SHARMA </td>
                          <td> I </td>
                          <td> X </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 125 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-12.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympaids1920-13.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 6 + GIFTS WORTH 1000 + ZONAL
                            BRONZE MEDAL CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKANSH JAIN </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 27+MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IVANA AGARWAL </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 + GIFTS WORTH 1000/- +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MYRA GARG </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 6 + GIFTS WORTH RS 1000/- + ZONAL
                            BRONZE MEDAL + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ATHARV KHANNA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 + GIFTS WORTH 1000/- +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SIBANI JAIN </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 21 + MEDAL AND CERTIFICATE OF
                            DISTINCTION CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARYAMAN GUPTA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 19 + MEDAL AND CERTIFICATE OF
                            DISTINCTION CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHVARDHAN KALRA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 3 + GIFTS WORTH 1000/- +
                            INTERNATIONAL BRONZE MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AVNI MITTAL </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1O + GIFTS WORTH RS. 1000/- MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH GOGIA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 + GIFTS WORTH 1000/- +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RUDRAKSH SINGH </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 4 + GIFTS WORTH RS 1000/- + ZONAL
                            GOLD MEDAL + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VANSH GUPTA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + MEDAL AND CERTIFICATE OF
                            DISTINCTION CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YUVIN GONUGUNTLA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 + GIFTS WORTH 1000/- +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANVAY GOYAL </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 + GIFTS WORTH 1000/- +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSHI AGARWAL </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 + GIFTS WORTH 1000/- +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARCHIT AGARWAL </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 9 + GIFTS WORTH Rs. 1000/- +
                            MEDAL AND CERTIFICATE OF DISTINCTION + CERTIFICATE
                            OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AADVIK GUPTA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 + GIFTS WORTH 1000/- +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAVYA SHETTY </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 + GIFTS WORTH 1000/- +
                            INTERNATIONAL GOLD MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRITIKA GUPTA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 + GIFTS WORTH RS. 1000/- +
                            MEDAL AND CERTIFICATE OF DISTINCTION + CERTIFICATE
                            OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RONAV PANDEY </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 10 + GIFTS WORTH RS. 1000/- +
                            MEDAL AND CERTIFICATE OF DISTINCTION + CERTIFICATE
                            OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VANYA YADAV </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 11 + GIFTS WORTH RS. 1000/- +
                            MEDAL AND CERTIFICATE OF DISTINCTION + CERTIFICATE
                            OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AAHANA BHADAURIA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 12 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANYA SHARMA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHIYA GARG </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 9 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IDA SINGH </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 16 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMBAR VASHISTH </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 14 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAARAV AGGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAN KHURANA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV PRASAD </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 19 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MANIT BHASIN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 4 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RIYAN VIR </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 26 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAAN JAIN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 14 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RUTVA GUPTA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22+ MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RISHIT VIKASH </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 12 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SVANIK GHAI </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ASHWANT ROY </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITWICK AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 24 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NETANYA SETHI </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 19 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YAJUR MEHRA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 4 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANNAN CHAWLA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 16 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RIDDHI GUPTA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA ARORA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 107 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHIT RASTOGI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> LEVEL II </td>
                          <td> </td>
                          <td> </td>
                          <td> </td>
                        </tr>
                        <tr>
                          <td> VIHAAN JAIN </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Gifts Worth Rs. 1000/- + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SVANIK GHAI </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            Rs. 3,125+ International Silver Medal + Certificate
                            of Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANYA MUNDRA </td>
                          <td> II </td>
                          <td> IV </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> SHAURYA ARORA </td>
                          <td> II </td>
                          <td> V </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                        <tr>
                          <td> SIDDHARTH MISHRA </td>
                          <td> II </td>
                          <td> X </td>
                          <td> Certificate of Zonal Excellence </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="heading2 text-center">
                    <h4>NATIONAL COMPUTERS OLYMPIAD (NCO)</h4>
                  </div>
                  <div class="table">
                    <table className="table-responsive" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <td> DHRUV BABBAR </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            International Rank 5 + Gifts Worth Rs. 1000/- +
                            Zonal Gold Medal + Certificate of Zonal
                            Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARNAV ARORA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            International Rank 13 + Gifts Worth Rs. 1000/- +
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DIYRA KAUR </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            International Rank 20 + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHVARDHAN KALRA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            International Rank 22 + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRISHA SINDHWANI </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            International Rank 35 + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ANVAY GOYAL </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            International Rank 22 + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARCHIT AGARWAL </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            International Rank 42+ Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRACHITA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            International rank 18 + Gifts Worth Rs. 1000/- +
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANYA ARYA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            International rank 1 + Gifts Worth Rs. 1000/- +
                            International Gold Medal + Certificate of
                            Outstanding performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAVYA SHETTY </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            International Rank 30 + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADHIMAN GUPTA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            International Rank 38 + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADVICK DUA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            International rank 10 + Rs. 2,500 + Zonal Silver
                            Medal + Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHANAYA AGGARWAL </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            International rank 38 + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VANYA YADAV </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            International Rank 3 + Gifts Worth Rs. 1000/- +
                            International Bronze Medal + Certificate of
                            Outstanding Performance{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AYAANSH DUA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            International rank 39 + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIHAN KHURANA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            International Rank 49 + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITWICK AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            International Rank 9 + Rs. 500 + Zonal Silver Medal
                            + Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            International Rank 53 + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            International Rank 5 + Rs. 5,000 + Zonal Gold Medal
                            + Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHAURYA ARORA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            International rank 28 + Rs. 200 + Zonal Bronze Medal
                            + Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MAYAN BHASKAR </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            International Rank 102 + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PRAKHAR BUKALSARIA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            International Rank 100 + Gifts Worth Rs. 1000/- +
                            Medal of Distinction + Certificate of Distinction +
                            Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHIT RASTOGI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            International Rank 7 + Rs. 5,000 + Zonal Gold Medal
                            + Certificate of Zonal Excellence{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SAGAR AGGARWAL </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            International Rank 135 + Certificate of Zonal
                            Excellence + Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SUCHIT SRIVASTAVA </td>
                          <td> I </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            International Rank 71 + Gifts Worth Rs. 1000/- +
                            Medal of Distinction + Certificate of
                            Distinction{" "}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              {filterData === "4" && (
                <div class="">
                  <div class="heading">
                    <h4>AUGMENTING KNOWLEDGE: OLYMPIADS 2018-19</h4>
                  </div>
                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <th colspan="3">
                            INTERNATIONAL GENERAL KNOWLEDGE OLYMPIAD (IGKO){" "}
                          </th>
                        </tr>

                        <tr>
                          <td>AISHA ARORA</td>
                          <td>I</td>
                          <td>
                            INTERNATIONAL RANK 10 GIFT WORTH Rs. 1000 + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>ARCHIT AGARWAL</td>
                          <td>I</td>
                          <td>
                            INTERNATIONAL RANK 62 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>DIVIJ ARORA</td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 74 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>EKAANSH AGARWAL</td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 29 GIFT WORTH Rs. 1000 + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>RITWICK AGARWAL</td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 49 GIFT WORTH Rs. 1000 + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>REYANSH AGARWAL</td>
                          <td>III</td>
                          <td>
                            INTERNATIONAL RANK 194 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>MAYAN BHASKAR</td>
                          <td>IV</td>
                          <td>
                            INTERNATIONAL RANK 228 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>TVESHA YADAV</td>
                          <td>V</td>
                          <td>
                            INTERNATIONAL RANK 510 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>HARSHITA PRABHAKAR</td>
                          <td>VII</td>
                          <td>
                            INTERNATIONAL RANK 286 GIFT WORTH Rs. 1000 + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <th colspan="3">NATIONAL CYBER OLYMPIAD (NCO)</th>
                        </tr>

                        <tr>
                          <td>AARAV PRASAD</td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 26 GIFTS WORTH RS 1000/- + MEDAL
                            AND CERTIFICATE OF DISTINCTION AND ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>ABIR ARORA</td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 35 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>ADITYA PATNAIK</td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 47 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>ARSHIYA GARG</td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 52 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>DARSH CHAWLA </td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 19 GIFTS WORTH RS 500/- + ZONAL
                            BRONZE MEDAL AND CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>DIVIJ ARORA</td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 40 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>EKAANSH AGARWAL</td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 22 GIFTS WORTH RS 1000/- + MEDAL
                            AND CERTIFICATE OF DISTINCTION AND ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>JAYANSH SAXENA</td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 48 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>RITWICK AGARWAL</td>
                          <td>II </td>
                          <td>
                            INTERNATIONAL RANK 19 GIFTS WORTH RS 500/- + ZONAL
                            BRONZE MEDAL AND CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>SUMANYU SHARNMA </td>
                          <td>II</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 35 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>SVANIK GHAI</td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 36 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>VIHAAN JAIN </td>
                          <td>II</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 21 GIFTS WORTH RS 1000/- + MEDAL
                            AND CERTIFICATE OF DISTINCTION AND ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>VIVAAN BHUSHAN </td>
                          <td>II</td>
                          <td>
                            INTERNATIONAL RANK 13 GIFTS WORTH RS 1000/- + MEDAL
                            AND CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>AKSHAYNI MATHUR </td>
                          <td>III</td>
                          <td>
                            INTERNATIONAL RANK 20 GIFTS WORTH RS 1000/- + MEDAL
                            AND CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>REYANSH AGARWAL </td>
                          <td>III</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 65 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>AARAV DEY </td>
                          <td>IV</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 66 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>ATISHAY JAIN </td>
                          <td>IV</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 71 MEDAL AND CERTIFICATE OF
                            DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>ISHIT RASTOGI </td>
                          <td>IV</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 44 GIFTS WORTH RS 1000/- + MEDAL
                            AND CERTIFICATE OF DISTINCTION AND ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>NAISHA SAWHNEY </td>
                          <td>IV</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 51 MEDAL AND CERTIFICATE OF
                            DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>PRAKHAR BUKALSARIA </td>
                          <td>IV</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 38 GIFTS WORTH RS 1000/- + MEDAL
                            AND CERTIFICATE OF DISTINCTION AND ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>PRIYANKA GUPTA </td>
                          <td>IV</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 74 MEDAL AND CERTIFICATE OF
                            DISTINCTION
                          </td>
                        </tr>
                        <tr>
                          <td>SAKSHAM JAIN </td>
                          <td>VII</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 55MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE
                          </td>
                        </tr>
                        <tr>
                          <td>ADITYA BHALLABH </td>
                          <td>XI</td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 3 GIFTS WORTH RS 1667/- +
                            INTERNATIONAL BRONZE MEDAL AND CERTIFICATE OF
                            OUTSTANDING PERFORMANCE.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="table">
                    <table className="table-view" border="1" width="100%">
                      <tbody>
                        <tr>
                          <th>NAME OF THE LEARNER</th>
                          <th>LEVEL</th>
                          <th>CLASS</th>
                          <th>AWARD WON</th>
                        </tr>
                        <tr>
                          <th colspan="4">
                            INTERNATIONAL GENERAL KNOWLEDGE OLYMPIAD (IGKO){" "}
                          </th>
                        </tr>
                        <tr>
                          <td> AARAV SHARMA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 24 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARCHIT AGARWAL </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 24 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AROHI BEEJWAT </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 3 + GIFT WORTH Rs. 1000
                            +INTERNATIONAL BRONZE MEDAL+ CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARSHIYA SINGH </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 38 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AVYA JINDAL </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 20 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KIARA J PRAKASH </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 11 + GIFT WORTH Rs. 1000 + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MAANAT SEHRA </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PAAKHI BHATNAGAR </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 35 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RONAV PANDEY </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 9 + GIFT WORTH Rs. 1000 + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMAIRA GARG </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 38 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MISHKA MENGHANI </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 3 + GIFT WORTH Rs. 1000
                            +INTERNATIONAL BRONZE MEDAL+ CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITWICK AGARWAL </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 39+ MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AHAAN GUPTA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 15 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AKSHAR MATTA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 34 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AKSHAYNI MATHUR </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 9 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARJUN WALIA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 32 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> GARVITA JAIN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 32 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KAAVYA JOSHI </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MEHAK JINDAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 34 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 4 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SARANYA SINGHAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 10 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHREYA MAMTANI </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 32 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SIDDHARTH BHASKAR </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 29 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SUHANA PALHAN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ALIA RATHI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 4 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARNAV JAIN </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARYAN GUPTA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AVANYA KHANNA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 29 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHAAN DAS </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> JASMEH KAUR SODHI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 4 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KRISHIV JAJAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MAYAN BHASKAR </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RISHI GUPTA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 33 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITISHA DWIVEDY </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 9 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHYLA TYAGI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 33 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TANISHKKKA AGGARWAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN KAMBOJ </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YATHARTH KUMAR BHUYAN </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 15 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AADYAA SAXENA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 39 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANYA SAHANI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 39 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV SINHA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 25 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AGASTYA TRIKHA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 25 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ASHMI MONGA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 39 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KHUSHI JOSHI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 5 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PALAK BHANDARI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 40 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYNA UPADHYAY </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 59 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHARANYA SINGH </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 65 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA ARORA </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 67 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAINA JHAAMB </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 77 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RAYANSH AGARWAL </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 38 +MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TEJAL DOSHI </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 39 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHITA AGARWAL </td>
                          <td> I </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 21 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA BALLABH </td>
                          <td> I </td>
                          <td> XI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 40 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMEYA ASHISH DEHADE </td>
                          <td> I </td>
                          <td> XI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 42 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAISHA JAIN </td>
                          <td> II </td>
                          <td> III </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- AND CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIR NIJHAWAN </td>
                          <td> II </td>
                          <td> III </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> AKSHAYNI MATHUR </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- AND CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SARANYA SINGHAL </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- AND CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMOGH DOSHI </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 5000/- , ZONAL GOLD MEDAL AND
                            CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TANISHKKKA AGGARWAL </td>
                          <td> II </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- AND CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN KAMBOJ </td>
                          <td> II </td>
                          <td> IV </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> SHIVANGI GUPTA </td>
                          <td> II </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- AND CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV ANAND </td>
                          <td> II </td>
                          <td> V </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> AARAV SINHA </td>
                          <td> II </td>
                          <td> V </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> KHUSHI JOSHI </td>
                          <td> II </td>
                          <td> V </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> REYNA UPADHYAY </td>
                          <td> II </td>
                          <td> V </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> SAARVIN SINGHAL </td>
                          <td> II </td>
                          <td> V </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> RAGHAV BANSAL </td>
                          <td> II </td>
                          <td> VI </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> II </td>
                          <td> VI </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> AARAV NAVANI </td>
                          <td> II </td>
                          <td> VII </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> SAUMYA BABBAR </td>
                          <td> II </td>
                          <td> VII </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> YASHITA AGARWAL </td>
                          <td> II </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- , ZONAL BRONZE MEDAL AND
                            CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TANVI ARORA </td>
                          <td> II </td>
                          <td> X </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> ADITYA BALLABH </td>
                          <td> II </td>
                          <td> XI </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> PAAKHI BHATNAGAR </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 35 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RONAV PANDEY </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 9 + GIFT WORTH Rs. 1000 + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMAIRA GARG </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 38 + MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MISHKA MENGHANI </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 3 + GIFT WORTH Rs. 1000
                            +INTERNATIONAL BRONZE MEDAL+ CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITWICK AGARWAL </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 39+ MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AHAAN GUPTA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 15 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AKSHAR MATTA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 34 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AKSHAYNI MATHUR </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 9 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARJUN WALIA </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 32 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> GARVITA JAIN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 32 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KAAVYA JOSHI </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MEHAK JINDAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 34 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 4 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SARANYA SINGHAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 10 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHREYA MAMTANI </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 32 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SIDDHARTH BHASKAR </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 29 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SUHANA PALHAN </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ALIA RATHI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 4 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARNAV JAIN </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 18 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ARYAN GUPTA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AVANYA KHANNA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 29 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHAAN DAS </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> JASMEH KAUR SODHI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 4 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KRISHIV JAJAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MAYAN BHASKAR </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 8 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RISHI GUPTA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 33 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITISHA DWIVEDY </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 9 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHYLA TYAGI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 33 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TANISHKKKA AGGARWAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 2 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN KAMBOJ </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YATHARTH KUMAR BHUYAN </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 15 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AADYAA SAXENA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 39 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AANYA SAHANI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 39 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV SINHA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 25 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AGASTYA TRIKHA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 25 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ASHMI MONGA </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 39 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> KHUSHI JOSHI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 5 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> PALAK BHANDARI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 40 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYNA UPADHYAY </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 59 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHARANYA SINGH </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 65 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA ARORA </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 67 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAINA JHAAMB </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 77 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RAYANSH AGARWAL </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 38 +MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TEJAL DOSHI </td>
                          <td> I </td>
                          <td> VII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 39 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> YASHITA AGARWAL </td>
                          <td> I </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 21 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA BALLABH </td>
                          <td> I </td>
                          <td> XI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 40 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMEYA ASHISH DEHADE </td>
                          <td> I </td>
                          <td> XI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 42 + MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> NAISHA JAIN </td>
                          <td> II </td>
                          <td> III </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- AND CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIR NIJHAWAN </td>
                          <td> II </td>
                          <td> III </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> AKSHAYNI MATHUR </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- AND CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SARANYA SINGHAL </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- AND CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMOGH DOSHI </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 5000/- , ZONAL GOLD MEDAL AND
                            CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TANISHKKKA AGGARWAL </td>
                          <td> II </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- AND CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> VIVAAN KAMBOJ </td>
                          <td> II </td>
                          <td> IV </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> SHIVANGI GUPTA </td>
                          <td> II </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- AND CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AARAV ANAND </td>
                          <td> II </td>
                          <td> V </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> AARAV SINHA </td>
                          <td> II </td>
                          <td> V </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> KHUSHI JOSHI </td>
                          <td> II </td>
                          <td> V </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> REYNA UPADHYAY </td>
                          <td> II </td>
                          <td> V </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> SAARVIN SINGHAL </td>
                          <td> II </td>
                          <td> V </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> RAGHAV BANSAL </td>
                          <td> II </td>
                          <td> VI </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> II </td>
                          <td> VI </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> AARAV NAVANI </td>
                          <td> II </td>
                          <td> VII </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> SAUMYA BABBAR </td>
                          <td> II </td>
                          <td> VII </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> YASHITA AGARWAL </td>
                          <td> II </td>
                          <td> IX </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- , ZONAL BRONZE MEDAL AND
                            CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> TANVI ARORA </td>
                          <td> II </td>
                          <td> X </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> ADITYA BALLABH </td>
                          <td> II </td>
                          <td> XI </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <th colspan="4">NATIONAL SCIENCE OLYMPIAD (NSO)</th>
                        </tr>
                        <tr>
                          <td> ARCHIT AGARWAL </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 3 GIFTS WORTH Rs. 1000 +
                            INTERNATIONAL BRONZE MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RONAV PANDEY </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 38 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA PATNAIK </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 6 Rs. 2500 + ZONAL SILVER MEDAL +
                            CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMBAR VASHISTH </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 27 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 3 GIFTS WORTH Rs. 1000 +
                            INTERNATIONAL BRONZE MEDAL + CERTIFICATE OF
                            OUTSTANDING PERFORMANCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RITWICK AGARWAL </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 11GIFT WORTH Rs. 1000 + MEDAL AND
                            CERTIFICATE OF DISTINCTION + CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMOGH DOSHI </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 35 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 35 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHIT RASTOGI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 28 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> HANEEKA MODI </td>
                          <td> I </td>
                          <td> V </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 56 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA ARORA </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 61 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RAGHAV BANSAL </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AGRIM GUPTA </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 45 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> II </td>
                          <td> III </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> AVIRAJ AGARWAL </td>
                          <td> II </td>
                          <td> III </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> ISHIT RASTOGI </td>
                          <td> II </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            ISHIT RASTOGI II IV GIFTS WORTH RS 1000/- AND
                            CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ADITYA ARORA </td>
                          <td> II </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 1000/- AND CERTIFICATE OF ZONAL
                            EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <th colspan="4"></th>
                        </tr>
                        <tr>
                          <th colspan="4">NATIONAL SCIENCE OLYMPIAD (NSO)</th>
                        </tr>
                        <tr>
                          <td> ARCHIT AGARWAL </td>
                          <td> I </td>
                          <td> I </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 17 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> DIVIJ ARORA </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> EKAANSH AGARWAL </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> IDA SINGH </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 14 GIFTS WORTH RS 1000/- + MEDAL
                            AND CERTIFICATE OF DISTINCTION + CERTIFICATE OF
                            ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MANIT BHASIN </td>
                          <td> I </td>
                          <td> II </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 15 MEDAL AND CERTIFICATE OF
                            DISTINCTION + CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AMOGH DOSHI </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 24 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> I </td>
                          <td> III </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> GARVIT SINGHAL </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 40 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> ISHIT RASTOGI </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 1 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> MAYAN BHASKAR </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 22 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> SHIVENN GUPTA </td>
                          <td> I </td>
                          <td> IV </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 40 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RAGHAV BANSAL </td>
                          <td> I </td>
                          <td> VI </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 4 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> AGRIM GUPTA </td>
                          <td> I </td>
                          <td> VIII </td>
                          <td>
                            {" "}
                            INTERNATIONAL RANK 10 MEDAL AND CERTIFICATE OF
                            DISTINCTION{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> REYANSH AGARWAL </td>
                          <td> II </td>
                          <td> III </td>
                          <td>
                            {" "}
                            GIFTS WORTH RS 2500/- , ZONAL GOLD MEDAL AND
                            CERTIFICATE OF ZONAL EXCELLENCE{" "}
                          </td>
                        </tr>
                        <tr>
                          <td> RAGHAV BANSAL </td>
                          <td> II </td>
                          <td> VI </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                        <tr>
                          <td> AGRIM GUPTA </td>
                          <td> II </td>
                          <td> VIII </td>
                          <td> CERTIFICATE OF ZONAL EXCELLENCE </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads1819-1.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads1819-2.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads1819-3.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads1819-4.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads1819-5.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads1819-6.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="heading2 text-center">
                    <h4>LOTUS VALLEY LEARNERS WIN LAURELS IN HINDI OLYMPIAD</h4>
                  </div>
                  <div>
                    <p>
                      Hindi Vikas Sansthan, Delhi organized the coveted Hindi
                      Olympiad on 21st August 2018 at Lotus Valley International
                      School, Gurgaon. Students from classes IV- X participated
                      in the test which evaluated their knowledge of Vocabulary,
                      Grammar, Subject proficiency and knowledge of eminent
                      literary figures of the Hindi Language. Students
                      participated in the Olympiad with much zeal and vigor. It
                      was evident in the result as the students made the school
                      proud with their outstanding performance. 5students (Yagan
                      Gupta – Grade 2, Riddhi Manocha – Grade 5, Khushi Joshi –
                      Grade 5, Vidyansh Kohli – Grade 8, Bhakti Bansal – Grade
                      8)received a special mention for securing the{" "}
                      <strong>1st Position at the National Level </strong>and
                      were honoured with trophies and certificates.
                    </p>
                    <p>
                      <strong>35 students</strong> received gold, bronze and
                      silver medals. Khushi Anand, who scored highest marks in
                      Hindi subject in CBSE Class 10 Board Exams, was also
                      honoured with trophy and certificate.{" "}
                    </p>
                    <p>
                      The students and their Mentor Mrs Sumanlata were
                      felicitated at a special ceremony organized by{" "}
                      <strong>Hindi Vikas Sansthan</strong>.
                    </p>
                  </div>
                  <div class="text-box gallery-sec">
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads1819-7.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                    <div class="gallery">
                      <div class="galleryBox">
                        <div class="gallery-pic">
                          <LazyLoad>
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/olympiads1819-8.webp"
                              className="img-fluid"
                              alt="Lotus Valley School, Gurgaon"
                            />
                          </LazyLoad>
                        </div>
                      </div>
                    </div>
                  </div>
                  <em>
                    <strong>NURTURING PRIDE IN THE NATIONAL LANGUAGE</strong>
                  </em>
                  <div class="headin2 text-center">
                    <h4>ATL LAB INNOVATIONS</h4>
                  </div>
                  <div>
                    <ul class="list">
                      <li>
                        Rishabh Garg &amp; Arnav Nagpal’s ATL project in
                        AGRITECH category selected in the top 25 in ATL Marathon
                        held in November 2018
                      </li>
                      <li>
                        Quadcop Video by Arnav Nagpal &amp; Pranav Goswamy
                        selected as Runners Up by Australian High Commission.
                        (Theme “Improve The Lives of Those Living In Smart
                        Cities &amp; Urban Areas)
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Olympiads;
